import PropTypes from 'prop-types';

const entity = PropTypes.shape({
	_id: PropTypes.number,
	title: PropTypes.string
});

const entities = PropTypes.arrayOf(entity);

const block = PropTypes.arrayOf(entity);

const blocks = PropTypes.objectOf(block.isRequired);

const rubric = PropTypes.shape({
	_id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	headingTitle: PropTypes.string
});

const rubricPage = PropTypes.shape({
	rubric,
	text: PropTypes.string,
	blocks: blocks.isRequired
});

const file = PropTypes.shape({
	_id: PropTypes.number.isRequired,
	type: PropTypes.string.isRequired,
	width: PropTypes.number,
	height: PropTypes.number,
	meta: PropTypes.shape({
		title: PropTypes.string
	})
});

const meta = PropTypes.shape({
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	keywords: PropTypes.string,
	og: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		thumbnailFile: file
	})
});

const entityType = PropTypes.oneOf([
	'broadcast',
	'movies',
	'institutes',
	'streamingPlatforms'
]);

const breadcrumbs = PropTypes.arrayOf(
	PropTypes.shape({
		title: PropTypes.string.isRequired,
		path: PropTypes.string.isRequired
	})
);

const link = PropTypes.shape({
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired
});

const compilation = PropTypes.shape({
	name: PropTypes.string.isRequired,
	description: PropTypes.string,
	entities: entities.isRequired,
	moreControl: link
});

const compilations = PropTypes.arrayOf(compilation);

const promoBlock = PropTypes.shape({
	_id: PropTypes.number,
	type: PropTypes.string.isRequired,
	placement: PropTypes.string
});

export const ThumbnailFileCropType = PropTypes.shape({
	x: PropTypes.number.isRequired,
	y: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired
});

export default {
	block,
	blocks,
	breadcrumbs,
	compilation,
	compilations,
	entities,
	entity,
	entityType,
	file,
	link,
	meta,
	promoBlock,
	rubric,
	rubricPage,
	ThumbnailFileCropType
};
